module.exports = __webpack_public_path__ + "img/1.2.b02806e4.jpg";